// extracted by mini-css-extract-plugin
export default {"overlay":"fA-z","bodyOpen":"gA-z","content":"hA-z","header":"iA-z","close":"jA-z","closeNoHeading":"kA-z"};